import React from "react";
import { ArrowUpRight } from "lucide-react";

// Lot 697 — cadre UNIQUE des cartes partagées dans une story (publication, lien, annonce en promo) :
// • même largeur pour toutes (70 % de la scène, ≤ 300 px, centrée) → des zones libres à gauche et à droite ;
// • le corps de la carte laisse passer les gestes (pointer-events: none) : tap gauche / droite = précédent / suivant,
//   appui long = pause, même sur la carte ;
// • seul le bouton d'action (pointer-events: auto) ouvre le contenu — un clic volontaire, jamais par erreur.
export const STORY_CARD_WIDTH = "w-[70%] max-w-[300px]";

export const StoryCardFrame = ({ children, cta, onCta, href, testId = "story-card-frame" }) => (
  <div className={`relative z-10 ${STORY_CARD_WIDTH} flex flex-col items-stretch gap-2 pointer-events-none`} data-testid={testId} data-story-card="1">
    {children}
    {cta && (href ? (
      <a href={href} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}
        className="pointer-events-auto self-center inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold text-white shadow-lg active:scale-95 transition-transform"
        style={{ background: "var(--yalola-primary)" }} data-testid={`${testId}-cta`}>
        {cta} <ArrowUpRight size={15} />
      </a>
    ) : (
      <button type="button" onClick={(e) => { e.stopPropagation(); onCta?.(); }}
        className="pointer-events-auto self-center inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold text-white shadow-lg active:scale-95 transition-transform"
        style={{ background: "var(--yalola-primary)" }} data-testid={`${testId}-cta`}>
        {cta} <ArrowUpRight size={15} />
      </button>
    ))}
  </div>
);
